import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: "30px 24px",
    maxWidth: 1400,
    margin: "0 auto",
    [theme.breakpoints?.down("md")]: {
      padding: "20px 16px",
    },
    [theme.breakpoints?.down("sm")]: {
      padding: "16px 12px",
    },
  },
  headerBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 28,
    flexWrap: "wrap",
    gap: 16,
    [theme.breakpoints?.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: 12,
    },
  },
  headerTitleGroup: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  headerIconPill: {
    width: 48,
    height: 48,
    borderRadius: 14,
    background: "linear-gradient(135deg, #2563EB 0%, #3B82F6 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFFFF",
    boxShadow: "0 6px 18px rgba(37, 99, 235, 0.3)",
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: "1.35rem",
    fontWeight: 800,
    color: "#0F172A",
    letterSpacing: "0.02em",
    [theme.breakpoints?.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  headerSubtitle: {
    fontSize: "0.85rem",
    color: "#64748B",
    fontWeight: 500,
  },

  // Compact Styled Year Selector for PC
  formControl: {
    width: 150,
    minWidth: 140,
    maxWidth: 160,
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    transition: "all 0.2s ease",
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor: "#FFFFFF",
      transition: "all 0.2s ease",
      boxShadow: "0 4px 14px rgba(15, 23, 42, 0.05)",
      "& fieldset": {
        borderColor: "#CBD5E1",
        borderWidth: 1.5,
        borderRadius: 14,
      },
      "&:hover fieldset": {
        borderColor: "#2563EB",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2563EB",
        borderWidth: 2,
      },
    },
    "& .MuiSelect-select": {
      padding: "8px 14px !important",
      fontSize: "0.9rem",
      fontWeight: 700,
      color: "#0F172A",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSelect-icon": {
      color: "#2563EB",
      right: 8,
      transition: "transform 0.2s ease",
    },
    [theme.breakpoints?.down("sm")]: {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
    },
  },

  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    margin: "0 12px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 20px 40px -8px rgba(37, 99, 235, 0.18)",
      borderColor: "#93C5FD",
    },
    [theme.breakpoints?.down("sm")]: {
      margin: "0 8px",
    },
  },
  contentMedia: {
    height: 200,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 16,
    [theme.breakpoints?.down("sm")]: {
      height: 150,
      padding: 12,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(180deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0.2) 60%, rgba(15, 23, 42, 0.75) 100%)",
      zIndex: 1,
    },
  },
  mediaTopRow: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    justifyContent: "flex-start",
  },
  activeMonthChip: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(8px)",
    color: "#FFFFFF",
    fontSize: "0.75rem",
    fontWeight: 800,
    padding: "4px 12px",
    borderRadius: 100,
    border: "1px solid rgba(255, 255, 255, 0.3)",
  },
  monthTitle: {
    position: "relative",
    zIndex: 2,
    color: "#FFFFFF",
    fontSize: "1.5rem",
    fontWeight: 900,
    letterSpacing: "-0.01em",
    textShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
  },
  cardBody: {
    padding: 20,
  },
  progressLabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#64748B",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    marginBottom: 4,
  },
  totalWatchedRow: {
    display: "flex",
    alignItems: "baseline",
    gap: 6,
    marginBottom: 12,
  },
  totalWatchedNum: {
    fontSize: "1.75rem",
    fontWeight: 900,
    lineHeight: 1,
  },
  totalWatchedDenom: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#64748B",
  },
  progressBarTrack: {
    height: 8,
    borderRadius: 100,
    backgroundColor: "#F1F5F9",
    overflow: "hidden",
    marginBottom: 20,
  },
  progressBarFill: {
    height: "100%",
    borderRadius: 100,
    transition: "width 0.5s ease",
  },
  btn_detail: {
    width: "100%",
    color: "#FFFFFF",
    fontWeight: 800,
    fontSize: "0.9rem",
    borderRadius: 12,
    padding: "10px 0",
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(37, 99, 235, 0.25)",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 6px 20px rgba(37, 99, 235, 0.35)",
    },
  },
}));

export default useStyles;
